/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GreenhouseInputs */

const en_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greenhouse`)
};

const th_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรือนกระจก`)
};

const ja_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`温室`)
};

const fr_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serre`)
};

const es_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invernadero`)
};

const ru_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теплица`)
};

const zh_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`温室`)
};

const vi_greenhouse = /** @type {(inputs: GreenhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà kính`)
};

/**
* | output |
* | --- |
* | "Greenhouse" |
*
* @param {GreenhouseInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const greenhouse = /** @type {((inputs?: GreenhouseInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GreenhouseInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_greenhouse(inputs)
	if (locale === "ja") return ja_greenhouse(inputs)
	if (locale === "fr") return fr_greenhouse(inputs)
	if (locale === "es") return es_greenhouse(inputs)
	if (locale === "ru") return ru_greenhouse(inputs)
	if (locale === "zh") return zh_greenhouse(inputs)
	if (locale === "vi") return vi_greenhouse(inputs)
	return en_greenhouse(inputs)
});